// extracted by mini-css-extract-plugin
module.exports = {"openModalBtn":"ChangeClinic_openModalBtn__1I8XK","footer":"ChangeClinic_footer__1CQ_X"};